const sortedArray = (
  array: any[],
  sortFunction: (a: any, b: any) => number
) => {
  return [...array].sort(sortFunction)
}

export default sortedArray
